import { API_URL } from "./utils";

async function request(path: string, options?: RequestInit) {
  const headers = new Headers(options?.headers);
  const hasBody = options?.body !== undefined && options?.body !== null;

  // Avoid forcing preflight on cross-origin GET requests.
  if (hasBody && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(`${API_URL}${path}`, {
    credentials: "include",
    ...options,
    headers,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ?? `Request failed: ${res.status}`);
  }
  return res.json();
}

export const api = {
  // Menu
  getMenu: () => request("/api/menu"),
  createMenuItem: (data: any) => request("/api/menu", { method: "POST", body: JSON.stringify(data) }),
  updateMenuItem: (id: number, data: any) => request(`/api/menu/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deleteMenuItem: (id: number) => request(`/api/menu/${id}`, { method: "DELETE" }),

  // Categories
  getCategories: () => request("/api/menu/categories"),
  createCategory: (data: any) => request("/api/menu/categories", { method: "POST", body: JSON.stringify(data) }),
  updateCategory: (id: number, data: any) => request(`/api/menu/categories/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deleteCategory: (id: number) => request(`/api/menu/categories/${id}`, { method: "DELETE" }),

  // Orders
  getOrders: (status?: string) => request(`/api/orders${status ? `?status=${status}` : ""}`),
  getOrder: (id: number) => request(`/api/orders/${id}`),
  updateOrderStatus: (id: number, status: string) =>
    request(`/api/orders/${id}/status`, { method: "PUT", body: JSON.stringify({ status }) }),
  deleteOrder: (id: number) => request(`/api/orders/${id}`, { method: "DELETE" }),
};
